import { MountpointGroupItem, useMountpointGroupsList, useNewMountpointGroup } from '../api'
import { CircularProgress, TextField, Typography } from '@material-ui/core'
import { strings } from '../strings'
import { Controller } from 'react-hook-form'
import { Autocomplete } from '@material-ui/lab'
import React, { CSSProperties } from 'react'
import { Control } from 'react-hook-form/dist/types/form'
import { FieldValues } from 'react-hook-form/dist/types/fields'
import { RegisterOptions } from 'react-hook-form/dist/types/validator'

interface Props {
  label: string
  name: string
  creator: boolean
  control: Control<FieldValues>
  defaultValue?: Array<number> | null
  rules?: Exclude<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>
  style?: CSSProperties
}

export function MountpointGroupMultiSelector(props: Props) {
  const { mountpointGroupsList, loading, error } = useMountpointGroupsList()
  const newMountpointGroup = useNewMountpointGroup()

  if (loading) return <CircularProgress size={16} />
  if (error) return <Typography color="error">{error.message}</Typography>
  if (!mountpointGroupsList) return <Typography color="error">{strings.notExists}</Typography>

  const handleGetOptionLabel = (x: any) => {
    if (!x) return null

    if (!creator || !x.inputValue) return x.name

    return x.inputValue
  }

  const handleFilterOptions = (options: Array<MountpointGroupItem>, params: any) => {
    if (!params.inputValue) return options

    let exact = false
    const value = params.inputValue.toUpperCase()
    const filtered: Array<any> = []

    if (creator) {
      for (const option of options) {
        const text = option.name.toUpperCase()
        if (value === text) exact = true
        if (text.indexOf(value) >= 0) filtered.push(option)
      }

      if (!exact) {
        filtered.push({
          inputValue: value,
          name: `${strings.creation} "${params.inputValue}"`,
        })
      }
    } else {
      for (const option of options) {
        const text = option.name.toUpperCase()
        if (text.indexOf(value) >= 0) filtered.push(option)
      }
    }

    return filtered
  }

  const handleGroupChanged = (options: any, onChange: any) => {
    if (!options || !options.length) {
      onChange([])
      return
    }

    if (!creator) {
      onChange(options.map((x: MountpointGroupItem) => x.id))
      return
    }

    const item = options[options.length - 1]
    const input = item.inputValue
    if (input) {
      newMountpointGroup(input)
        .then((groupId) => {
          mountpointGroupsList.push({ id: groupId, name: input })
          item.id = groupId
          onChange(options.map((x: MountpointGroupItem) => x.id))
        })
        .catch((err) => {
          onChange(options.slice(0, -1).map((x: MountpointGroupItem) => x.id))
          console.log(err.message)
        })
    } else {
      onChange(options.map((x: MountpointGroupItem) => x.id))
    }
  }

  const { label, name, creator, control, defaultValue, rules, style } = props

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ value, onChange }) => (
        <Autocomplete
          multiple
          freeSolo
          clearOnBlur
          disableClearable
          filterSelectedOptions
          size="small"
          options={mountpointGroupsList.sort((a, b) =>
            a.name > b.name ? 1 : a.name < b.name ? -1 : 0,
          )}
          renderOption={(x) => x.name}
          getOptionLabel={handleGetOptionLabel}
          value={value && value.map((id: number) => mountpointGroupsList.find((x) => x.id === id))}
          onChange={(e, o) => handleGroupChanged(o, onChange)}
          filterOptions={handleFilterOptions}
          style={style}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              autoComplete="off"
              variant="outlined"
              label={label}
            />
          )}
        />
      )}
    />
  )
}
